import { StyledSVG } from './loader.style';

const sizes = {
  tiny: {
    width: '8px',
    height: '8px',
  },
  small: {
    width: '25px',
    height: '25px',
  },
  normal: {
    width: '20px',
    height: '20px',
  },
  medium: {
    width: '50px',
    height: '50px',
  },
  extraMedium: {
    width: '100px',
    height: '100px',
  },
  big: {
    width: '150px',
    height: '150px',
  },
  large: {
    width: '200px',
    height: '200px',
  },
};
// const strokeColor = {
//   primary: '#277bce',
//   light: '#ffffff',
// };
const Spinner = (props) => {
  const { size = 'normal' } = props;
  return (
    <>
      <StyledSVG
        xmlns="http://www.w3.org/2000/svg"
        width={sizes[size].width}
        height={sizes[size].height}
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <g transform="rotate(0 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#fe718d">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.5729166666666666s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(30 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#f47e60">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.5208333333333333s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(60 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#f8b26a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.46874999999999994s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(90 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#abbd81">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.41666666666666663s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(120 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#849b87">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.36458333333333326s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(150 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#6492ac">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.31249999999999994s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(180 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#637cb5">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.26041666666666663s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(210 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#6a63b6">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.20833333333333331s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(240 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#fe718d">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.15624999999999997s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(270 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#f47e60">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.10416666666666666s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(300 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#f8b26a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="-0.05208333333333333s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(330 50 50)">
          <rect x="47" y="13" rx="3" ry="9" width="6" height="18" fill="#abbd81">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="0.625s"
              begin="0s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
      </StyledSVG>
    </>
  );
};

export default Spinner;
